/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useContext} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC, API_SERVER, API_LOGIN, API_UPLOADS } from '../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { NavLink, useHistory } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {reactLocalStorage} from 'reactjs-localstorage';
import TextTransition, { presets } from "react-text-transition";
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Context]
-------------------------------------------------------------------*/
import { UserContext, LocationContext } from '../../../../context/container'
/*------------------------------------------------------------------
[End Context]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Route JSON]
-------------------------------------------------------------------*/
import { route, route_name } from "../@api.json";
/*------------------------------------------------------------------
[End Route JSON]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../../../style/general/node.entry.css';
import '../../../../style/admin/node.admin.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character } from "../../../../functions";
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

const Screen = ({loading, error, setting}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    const [menu, set_menu] = useState(false);

    const [username, set_username] = useState('');

    const [password, set_password] = useState('');

    const [refresh, set_refresh] = useState(false);

    const [version, set_version] = useState('')

	//#region redux ------------------------------------------------

	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}

	//#endregion redux ---------------------------------------------

    /*--------------------------------------------------------------
    [Context]
    ----------------------------------------------------------------*/
    const { user, set_user } = useContext(UserContext);
    const { location, set_location } = useContext(LocationContext);
    /*--------------------------------------------------------------
    [End Context]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Redirect]
    ----------------------------------------------------------------*/
    if(STORAGE_USER){
        if(STORAGE_USER[0].level === 'guest'){
            history.push('/')
            set_location('public')
        }else if(STORAGE_USER[0].level === 'super'){
            history.push('/')
        }else if(STORAGE_USER[0].level === 'admin'){
            history.push('/')
        }else if(STORAGE_USER[0].level === 'user'){
            history.push('/')
        }
    }
    /*--------------------------------------------------------------
    [End Redirect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read_version = () => {

        if(loading === true){
            return
        }

		loading(true);

		API_GET_PUBLIC('version/public__________?key=' + random_character(32)
			+ '&slug=web'
        , 
		).then((response) => {
            console.log('version', JSON.stringify(response.data, undefined, 2))
            if(response.data.result == 'success'){
                set_version(response.data.data[0].version)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}

    const _login = () => {

        if(loading === true){
            return
        }

		loading(true);

		API_LOGIN(`${route}/login__________`, {
			username: username,
			password: password
		})
        .then((response) => {
			if(response.data.result === 'success'){
                if(response.data.user[0].level === 'admin'){
                    reactLocalStorage.set('@token', response.data.data);
                    reactLocalStorage.set('@user', JSON.stringify(response.data.user));
                    set_user(JSON.stringify(response.data.user))
                    // history.push('/otomotif/home')
                    window.location.reload();
                }else{
                    error('Anda login sebagai pengguna. Silahkan unduh aplikasi kami')
                }
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Browser]
	----------------------------------------------------------------*/
	const _browser = () => {

        // Opera 8.0+
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

        // Firefox 1.0+
        var isFirefox = typeof InstallTrigger !== 'undefined';

        // Safari 3.0+ "[object HTMLElementConstructor]" 
        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;

        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;

        // Chrome 1 - 71
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

        // Blink engine detection
        var isBlink = (isChrome || isOpera) && !!window.CSS;

        if(isFirefox){
            error('Detect Firefox : Direkomendasikan menggunakan browser Google Chrome demi mendapatakan pengalaman terbaik')
        }else if(isChrome){

        }else if(isSafari){
            error('Detect Safari : Direkomendasikan menggunakan browser Google Chrome demi mendapatakan pengalaman terbaik')
        }else if(isOpera){
            error('Detect Opera : Direkomendasikan menggunakan browser Google Chrome demi mendapatakan pengalaman terbaik')
        }else if(isIE){
            error('Detect IE : Direkomendasikan menggunakan browser Google Chrome demi mendapatakan pengalaman terbaik')
        }else if(isEdge){
            error('Detect Edge : Direkomendasikan menggunakan browser Google Chrome demi mendapatakan pengalaman terbaik')
        }else if(isBlink){
            error('Detect Blink : Direkomendasikan menggunakan browser Google Chrome demi mendapatakan pengalaman terbaik')
        }

	}
	/*--------------------------------------------------------------
	[End Browser]
	----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

		_browser();
        _read_version();

        set_location(history.location.pathname)

    }, [refresh])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Text Animation]
    ----------------------------------------------------------------*/
    const [index, setIndex] = React.useState(0);

    React.useEffect(() => {
        const intervalId = setInterval(() =>
        setIndex(index => index + 1),
        3000 // every 3 seconds
        );
        return () => clearTimeout(intervalId);
    }, []);

    const TEXTS = [
        "Login",
        "Official"
    ];
    /*--------------------------------------------------------------
    [End Text Animation]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        <>
            <Helmet>

                <meta name="description" content={'Login'}/>
                <title>{'Login'}</title>

            </Helmet>

            <div className="_navbar_menu">
                <NavLink 
                    to={{
                        pathname: "https://play.google.com/store/apps/details?id=cloud.gmqrs.flamecore",
                    }}
                    target="_blank"
                    className="_menu"
                >
                    <div className="_row _center_align">
                        <ion-icon name="logo-google-playstore" style={{marginRight: 8, fontSize: 18}}></ion-icon>
                        <span style={{fontSize: 14}}>
                            Scanner QR
                        </span>
                    </div>
                </NavLink>
            </div>
            <div className="_bb-position-overlay-form">
                {
                    setting &&
                    <div className="_image">
                        <div className="_middle">
                            <img src={API_UPLOADS + setting.logo} style={{width: 150}} />
                            <br/>
                            <p style={{color: '#000', maxWidth: 400, margin: 'auto', textAlign: 'center', fontSize: 20}}>
                                {setting.description}
                            </p>
                        </div>
                    </div>
                }
                <div className="_form" style={{marginTop: 60}}>
                    <div>
                        <div className="_row" style={{marginTop: -30}}>
                            <div>
                                <h1 style={{color: '#118ab2', fontSize: 45}}>e-</h1>
                            </div>
                            <div className="_column">
                                <h1 style={{marginBottom: 30, textAlign: 'center', fontSize: 45}}>
                                    <span>
                                        <TextTransition
                                            text={ TEXTS[index % TEXTS.length] }
                                            springConfig={ presets.wobbly }
                                        />
                                    </span>
                                </h1>
                            </div>
                        </div>

                        <div className="_form_box">
                            <div>
                                <div className="_relative _push_b_l _push_t_m">
                                    <p className="_overflow_hidden"><ion-icon name="footsteps-outline" style={{fontSize: 18, float: 'left', marginRight: 6}}></ion-icon> Email</p>
                                    <div className="_bb-input">
                                        <input 
                                            placeholder="" 
                                            onChange={e => set_username(e.target.value)}
                                            value={username}
                                        />
                                    </div>
                                </div>
                                <div className="_relative _push_b_d">
                                    <p className="_overflow_hidden"><ion-icon name="lock-closed-outline" style={{fontSize: 18, float: 'left', marginRight: 6}}></ion-icon> Password</p>
                                    <div className="_bb-input">
                                        <input 
                                            type="password"
                                            onChange={e => set_password(e.target.value)}
                                            value={password} 
                                        />
                                    </div>
                                </div>
                                <p style={{textAlign: 'right'}}> 
                                    <NavLink 
                                        to={{
                                            pathname: `/${route}/forget/password`,
                                        }}
                                        style={{color: '#118ab2'}}
                                    >
                                        Lupa Password ?
                                    </NavLink>
                                </p>
                                <div className="_bb-btn _push_t_d" onClick={() => _login()}>
                                    Masuk
                                </div> 
                            </div>
                            
                        </div>
                        <div style={{position: 'relative', zIndex: 3}}>
                            <p style={{marginTop: 16, marginTop: 16, marginBottom: 52, textAlign: 'center'}}>Belum punya akun? silahkan {` `} 
                                <NavLink 
                                    to={{
                                        pathname: `/${route}/register`,
                                    }}
                                    style={{color: '#118ab2'}}
                                >
                                    Registrasi
                                </NavLink>
                            </p>
                            <p style={{marginTop: 16, textAlign: 'center'}}>App {version} Powered By <a href="https://flamecore.cloud" style={{color: '#118ab2'}}>Flamecore Cloud</a></p> 
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;